import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

export enum SECTION_DIVIDER_VARIATION {
    NORMAL = "normal",
    REVERSE = "reverse",
    FLIP = "flip",
    REVERSE_FLIP = "reverse-flip"
}

type Adg4SectionDividerProps = {
    bgColor?: string | ReturnType<typeof token>;
    colorAgainst?: string | ReturnType<typeof token>;
    desktopHeight?: number;
    tabletHeight?: number;
    mobileHeight?: number;
    variation?:
        | SECTION_DIVIDER_VARIATION.NORMAL
        | SECTION_DIVIDER_VARIATION.REVERSE
        | SECTION_DIVIDER_VARIATION.FLIP
        | SECTION_DIVIDER_VARIATION.REVERSE_FLIP;
};
export const Adg4SectionDivider = ({
    bgColor = "#1868DB",
    colorAgainst = "#FFF",
    desktopHeight = 120,
    tabletHeight = 80,
    mobileHeight = 60,
    variation
}: Adg4SectionDividerProps) => {
    const sectionDividerStyles = css({
        clipPath: "polygon(0 100%, 100% 0, 100% 100%, 0% 100%)",
        background: bgColor,
        height: `${desktopHeight}px`,

        [media.only.sm]: {
            height: `${tabletHeight}px`
        },
        [media.below.sm]: {
            height: `${mobileHeight}px`
        }
    });

    const colorBehindDividerStyles = css({
        backgroundColor: colorAgainst
    });

    return (
        <div css={colorBehindDividerStyles}>
            <div
                css={[
                    sectionDividerStyles,
                    variation === SECTION_DIVIDER_VARIATION.REVERSE
                        ? css({
                              clipPath:
                                  "polygon(100% 100%, 0 0, 0 100%, 100% 100%)"
                          })
                        : css({}),
                    variation === SECTION_DIVIDER_VARIATION.FLIP
                        ? css({
                              clipPath: "polygon(0 0, 100% 100%, 100% 0, 0 0)"
                          })
                        : css({}),
                    variation === SECTION_DIVIDER_VARIATION.REVERSE_FLIP
                        ? css({ clipPath: "polygon(100% 0, 0 100%, 0 0)" })
                        : css({})
                ]}
            />
        </div>
    );
};
